import { updateSyncPages } from '@lib/axios/syncPages'
import { useMutation, useQueryClient } from 'react-query'
import useSuccess from '@hooks/useSuccess'
import useCloseDialog from '@hooks/useCloseDialog'

const useUpdate = () => {
  const showSuccess = useSuccess('Sukses', 'Sukses Mengubah Setup Store Dashboard Page')
  const closeDialog = useCloseDialog()
  const queryClient = useQueryClient()
  const mutation = useMutation(
    // id, name, parent_id, order, path, icon
    (mdata) => updateSyncPages(
      mdata.id,
      mdata.name,
      mdata.parent_id,
      mdata.order,
      mdata.path,
      mdata.icon
    ),
    {
      onSuccess: () => {
        queryClient.invalidateQueries('saas-sync-pages')
      },
    }
  )

  return (data) => mutation.mutate(data, {
    onError: () => closeDialog(),
    onSuccess: () => {
      showSuccess()
    },
  })
}

export default useUpdate
